/* Leave the detail caption unobstructed while the framed panel is being read. */
(() => {
  'use strict';
  const inside=document.getElementById('viulet-v36').querySelector('#inside');
  if(!inside || !('IntersectionObserver' in window)) return;
  const observer=new IntersectionObserver(entries=>{
    document.getElementById('viulet-v36').classList.toggle('viewing-art-detail',entries[0].isIntersecting);
  },{threshold:.18});
  observer.observe(inside);
})();
